import { useEffect } from "react";
import { getTextDirection } from "../../api/ownerdatas";
import { useUserContext } from "../../contexts/userContext";
import UpdateInfo from "./UpdateInfo";
import { useDashboardStore } from "../../stores/dashboard";
import { getOwnerData } from "../../api/ownerData";
import { showToastError } from "../../services/toast";
import { useTranslation } from "react-i18next";
import { ActionButton } from "../ui/page/PageShell";

const InforDirection = () => {
  //Hooks
  const { t } = useTranslation();
  const { role, typeRole } = useUserContext();
  const {
    openModalInforDirection,
    setOpenModalInforDirection,
    textDirection,
    setTextDirection,
  } = useDashboardStore();

  useEffect(() => {
    if (typeRole !== "Customer") {
      getTextDirection()
        .then((response) => {
          setTextDirection(response.data);
        })
        .catch((err) => {
          showToastError(err.response.data.message);
        });
    } else {
      getOwnerData()
        .then((response) => {
          setTextDirection(response.data);
        })
        .catch((err) => {
          showToastError(err.response.data.message);
        });
    }
  }, [openModalInforDirection]);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      {openModalInforDirection && <UpdateInfo />}

      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span
            aria-hidden="true"
            className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-slate-50 text-slate-500 ring-1 ring-slate-200 ring-inset"
          >
            <svg
              className="size-5"
              fill="none"
              stroke="currentColor"
              strokeWidth={1.8}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
          </span>

          <h2 className="font-Nunito text-base font-bold text-slate-900">
            {typeRole === "Customer"
              ? t("Information client")
              : t("Information direction")}
          </h2>
        </div>

        {(role === "Direction" || role === "Admin") && (
          <ActionButton onClick={() => setOpenModalInforDirection(true)}>
            Modifier
          </ActionButton>
        )}
      </div>

      <div className="mt-4 rounded-xl bg-slate-50 px-4 py-3 ring-1 ring-slate-100 ring-inset">
        <p className="font-Nunito text-sm leading-relaxed text-slate-600">
          {textDirection || (
            <span className="text-slate-400 italic">
              {t(
                "Aucune information de direction disponible pour le moment...",
              )}
            </span>
          )}
        </p>
      </div>
    </section>
  );
};

export default InforDirection;
